import { observer } from 'mobx-react-lite'
import { Box, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IReviewViewStepProps = {
  blockId: string
  title: string
  description: string
}

export const ReviewViewStep = observer(({ blockId, title, description }: IReviewViewStepProps) => {
  return (
    <Box className={styles.block}>
      <div className={styles.blockId}>
        <Typography
          ariaLabel={`WidgetChat_${blockId}_blockId`}
          variant='body-sm-medium'
          color='var(--content-primary-primary)'
        >
          {blockId}
        </Typography>
      </div>
      <Typography ariaLabel={`WidgetChat_${blockId}_title`} variant='body-lg-medium'>
        {title}
      </Typography>
      <Typography
        ariaLabel={`WidgetChat_${blockId}_description`}
        variant='body-md-regular'
        color='var(--content-primary-secondary)'
      >
        {description}
      </Typography>
    </Box>
  )
})
